import { SELECT_THEME } from './themes.types';
export const setSelectedTheme = value => ({
    type: SELECT_THEME,
    payload: value,
});
